import { render, staticRenderFns } from "./scopeSettingsForm.vue?vue&type=template&id=499e7a26&scoped=true&"
import script from "./scopeSettingsForm.vue?vue&type=script&lang=js&"
export * from "./scopeSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499e7a26",
  null
  
)

export default component.exports